import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getNotionActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({notion}: BackupState) => notion.actions);
export const getNotionActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({notion}: BackupState) => notion.totalActions);
export const isNotionActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({notion}: BackupState) => notion.loading);
export const getNotionCanRestore = createSelector((state: DefaultRootState) => state.backups, ({notion}: BackupState) => notion.canRestore);
